/**
 * Overwritten by scripts/inject-stripe-env.js in CI before bundle.
 * Do not commit a non-empty literal — the prod and test publishable keys differ per environment.
 */
export const STRIPE_PUBLISHABLE_KEY_GENERATED = "pk_live_51TSIP41ZSaZJSUEWEF6Y0Upi8dpP9S4yor7UKNdWfgAjR53XoJSOtatURgqamOU2lGSL0nl1LifLhNZcQ8r6fJS600MTEXITRd"
